<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-human-greeting',
          title: 'Confianza',
          text: 'La confianza que han depositado los clientes en nuestra organización ha permitido consolidarnos como una empresa de referencia en nuestro sector. Supone un estímulo, una inyección de moral y a su vez una obligación para seguir trabajando con el fin de atender cada vez mejor las necesidades de nuestros clientes.',
        },
        {
          icon: ' mdi-clipboard-edit',
          title: 'Flexibilidad',
          text: 'La flexibilidad es un valor identificador, diferenciador, que se manifiesta de forma directa en la relación con nuestros clientes y proveedores.',
        },
        {
          icon: ' mdi-check-underline-circle-outline',
          title: 'Calidad',
          text: 'La calidad, basada en la profesionalidad del equipo humano de CYD GROUP en su experiencia e innovación, es el eje de nuestra relación con los clientes',
        },
        {
          icon: 'mdi-briefcase-check',
          title: 'Compromiso',
          text: 'El compromiso, dinamismo y capacidad de adaptación nos permite adecuarnos a las necesidades de cada cliente',
        },
      ],
    }),
  }
</script>
